define('vspot-angular/services/org-event-service',[], function () {
    'use strict';

    return ['resources.OrgEvent', function (OrgEvent) {
        return {
            /*
             * Get a list of all the events for an activity.
             *
             * @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: {
             *            ???
             *                  }
             */
            /*** A single Event ***/
            get: function(eventId) {
                //return OrgEvent.get({ selected_activity: activityId });
            },

            /*
             * Return a list of all the events for an activity.
             * TODO  -- Set date and other prams  -- Serna 02/03/2017
             */
            query: function(activityId) {
                return OrgEvent.query({
                    selected_activity:  activityId
                });
            },

            /*
             * Return a list of all the events for an activity.
             */
            report: function(query) {
                return OrgEvent.query(query);
            },



            delete: function(id, activityId) {
                return OrgEvent.delete({
                    id: id,
                    selected_activity:  activityId
                });
            },

            /*
             *  Deletes multiple events.
             *
             *  @param {int} - The id of the activity.
             *  @param {array} - An array of date strings of the format 'yyyy-mm-dd'
             */
            deleteMultiple: function(activityId, dates) {
                return OrgEvent.deleteMultiple({
                    selected_activity: activityId,
                    days: dates
                });
            },

            lock: function(id, activityId, permanent) {
                return OrgEvent.lock({
                    event_id:           id,
                    selected_activity:  activityId,
                    permanent:          permanent ? "true" : "false"
                });
            },

            unlock: function(id, activityId, permanent) {
                return OrgEvent.unlock({
                    event_id:           id,
                    selected_activity:  activityId,
                    permanent:          permanent ? "true" : "false"
                });
            },

            /*
             * copyDay:
             *      Copy an event (day) to another day on the current activity
             *  @param int eventId - id of the event to copy.
             *  @param array dates - array of dates to copy the day to (yyyy-mm-dd) format.
             *  @param boolean assignments - include the assignments from this day?
             *  @param {boolean} force - whether to force overwriting of days with assignments.
             *  @param {boolean} merge - whether to merge instead of replace the day.
             */
            copyDay: function(activityId, eventId, dates, assignments, force, merge) {
                if(typeof(force) === "undefined") {
                    force = false;
                }
                // If we are merging, then the force flag needs to be true. But, it's okay,
                // because we are merging, not overwriting.
                if( merge === true ) {
                    force = true;
                }
                return OrgEvent.copyDay({
                    selected_activity:  activityId,
                    event_id:           eventId,
                    dates:              dates,
                    assignments:        assignments,
                    force:              force ? "true" : "false",
                    merge:              merge ? "true" : "false"
                });
            },

            /*
             * copyDayToNewActivity:
             *      Copy an event (day) to a new activity
             *  @param int eventId - id of the event to copy.
             *  @param int toActivityId - id of the activity to copy the event to.
             *  @param array dates - array of dates to copy the day to (yyyy-mm-dd) format.
             *  @param {boolean} force - whether to force overwriting of days with assignments.
             *  @param {boolean} merge - whether to merge instead of replace the day.
             */
            copyDayToNewActivity: function(activityId, eventId, toActivityId, dates, force, merge) {
                if(typeof(force) === "undefined") {
                    force = false;
                }
                // If we are merging, then the force flag needs to be true. But, it's okay,
                // because we are merging, not overwriting.
                if( merge === true ) {
                    force = true;
                }
                return OrgEvent.copyDayToNewActivity({
                    selected_activity:  activityId,
                    event_id:           eventId,
                    dest_id:            toActivityId,
                    dates:              dates,
                    force:              force ? "true" : "false",
                    merge:              merge ? "true" : "false"
                });
            }
        };
    }];
});

